import { UserPermissions } from "~/server/api/helpers/permissionHelpers";
import { CommunityPage } from "~/types/CommunityTypes";
import {
    CommunityCustomBanner,
    CommunityCustomBannerUtahTechWeek,
} from "./CommunityCustomBanner";
import { WantToHostEvent } from "./WantToHostEvent";

const ConditionalCommunityBanner = ({
    community,
    permissions,
    isFollower,
    customBanner,
}: {
    community: Omit<CommunityPage, "leaders" | "topHosts">;
    permissions: UserPermissions;
    isFollower: boolean;
    customBanner?: PrismaJson.CustomBanner | null;
}) => {
    if (!permissions.isMember && customBanner?.conditionType === "membership") {
        return (
            <CommunityCustomBanner
                customBanner={customBanner}
                communitySlug={community.slug}
                type="membership"
            />
        );
    }

    if (!isFollower && customBanner?.conditionType === "follower") {
        return (
            <CommunityCustomBanner
                customBanner={customBanner}
                communitySlug={community.slug}
                type="follower"
            />
        );
    }

    return <WantToHostEvent community={community} permissions={permissions} />;
};

export default ConditionalCommunityBanner;
